"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowIdHttpAdapterNS = exports.FlowIdLambdaAdapterNS = exports.FlowIdSNSAdapterNS = exports.FlowIdSQSAdapterNS = void 0;
var FlowIdSQSAdapterNS;
(function (FlowIdSQSAdapterNS) {
    FlowIdSQSAdapterNS.FLOW_ID_SQS_ADAPTER_ID = Symbol.for("FlowIdSQSAdapter");
})(FlowIdSQSAdapterNS = exports.FlowIdSQSAdapterNS || (exports.FlowIdSQSAdapterNS = {}));
var FlowIdSNSAdapterNS;
(function (FlowIdSNSAdapterNS) {
    FlowIdSNSAdapterNS.FLOW_ID_SNS_ADAPTER_ID = Symbol.for("FlowIdSNSAdapter");
})(FlowIdSNSAdapterNS = exports.FlowIdSNSAdapterNS || (exports.FlowIdSNSAdapterNS = {}));
var FlowIdLambdaAdapterNS;
(function (FlowIdLambdaAdapterNS) {
    FlowIdLambdaAdapterNS.FLOW_ID_LAMBDA_ADAPTER_ID = Symbol.for("FlowIdLambdaAdapter");
})(FlowIdLambdaAdapterNS = exports.FlowIdLambdaAdapterNS || (exports.FlowIdLambdaAdapterNS = {}));
var FlowIdHttpAdapterNS;
(function (FlowIdHttpAdapterNS) {
    FlowIdHttpAdapterNS.FLOW_ID_HTTP_ADAPTER_ID = Symbol.for("FlowIdHttpAdapter");
})(FlowIdHttpAdapterNS = exports.FlowIdHttpAdapterNS || (exports.FlowIdHttpAdapterNS = {}));
//# sourceMappingURL=flow-id-adapters.types.js.map